import styles from './styles.module.scss'
import insta from '../../assets/icons/instagram.svg'
import fb from '../../assets/icons/f.svg'
import tik from '../../assets/icons/tiktok.svg'
import yt from '../../assets/icons/yt.svg'
import logo from '../../assets/logo.webp'

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.upperwrapper}>
                <a href='#home' aria-label="Maneliada - Înapoi la începutul paginii">
                    <img src={logo} alt="Maneliada" style={{ height: '4rem', width: 'auto' }} />
                </a>
                <nav className={styles.menu} aria-label="Navigare principală subsol">
                    <a href='#home'>
                        <p>Acasă</p>
                    </a>
                    <a id="footer-bilete" href='https://bilete.maneliada.ro/' target='_blank' rel='noreferrer noopener' >
                        <p>Bilete</p>
                    </a>
                    <a href='mailto:contact@maneliada.ro'>
                        <p>Contact</p>
                    </a>
                </nav>
                <div className={styles.socialWrapper} aria-label="Canale sociale Maneliada">
                    <a href='https://facebook.com/maneliada' target='_blank' rel='noreferrer noopener' aria-label="Maneliada pe Facebook">
                        <img src={fb} alt="" aria-hidden="true" width="30" height="30" />
                    </a>
                    <a href='https://instagram.com/maneliada' target='_blank' rel='noreferrer noopener' aria-label="Maneliada pe Instagram">
                        <img src={insta} alt="" aria-hidden="true" width="30" height="30" />
                    </a>
                    <a href='https://tiktok.com/@maneliada_ofc' target='_blank' rel='noreferrer noopener' aria-label="Maneliada pe TikTok">
                        <img src={tik} alt="" aria-hidden="true" width="30" height="30" />
                    </a>
                    <a href='https://www.youtube.com/@maneliadatv' target='_blank' rel='noreferrer noopener' aria-label="Maneliada pe YouTube">
                        <img src={yt} alt="" aria-hidden="true" width="30" height="30" />
                    </a>
                </div>

            </div>
            <div className={styles.line} role="separator" aria-hidden="true" />
            <div className={styles.lowerWrapper}>
                <p className={styles.copyright}>© 2021 - {new Date().getFullYear()} MANELIADA</p>
                <nav className={styles.menu} aria-label="Informații legale">
                    <a href='https://maneliada-termeni.s3.eu-west-1.amazonaws.com/politica-de-confidentialitate.pdf' target='_blank' rel='noreferrer noopener' >
                        <p>POLITICĂ DE CONFIDENȚIALITATE</p>
                    </a>
                    <div className={styles.verticalLine} role="separator" aria-hidden="true" />
                    <a href='https://maneliada-termeni.s3.eu-west-1.amazonaws.com/termeni-si-conditii-Maneliada-2024.pdf' target='_blank' rel='noreferrer noopener' >
                        <p>TERMENI ȘI CONDIȚII</p>
                    </a>
                </nav>
            </div>

        </footer>
    )
}

export default Footer
